import "./localization";
import { Roulette } from "./roulette";
import options from "./options";

export function createRoulette(container?: HTMLElement) {
  const roulette = new Roulette(container);
  // @ts-ignore
  window.roullete = roulette;
  // @ts-ignore
  window.options = options;
  return roulette;
}
